import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        gap: tokens.spacingHorizontalMNudge,
        alignItems: 'flex-start',
    },
    item: {
        display: 'flex',
        flexDirection: 'row',
        gap: '5px',
    },
    span: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
    },
    labelBold: {
        fontWeight: tokens.fontWeightSemibold,
    },
    labelNormal: {
        fontWeight: tokens.fontWeightRegular,
    },
});

export interface IReportColumnContextProps {
    case: string;
    entity: string;
    jurisdiction: string;
    year: string;
}

const ReportColumnContext: FC<IReportColumnContextProps> = (props: IReportColumnContextProps) => {
    const { t } = useTranslation();
    const styles = useStyles();
    const boldLabelStyles = mergeClasses(styles.span, styles.labelBold);
    const normalLabelStyles = mergeClasses(styles.span, styles.labelNormal);

    return (
        <div id='reportColumnContext' className={styles.root}>
            <div className={styles.item}>
                <span className={boldLabelStyles}>{t('entity')}:</span>
                <span className={normalLabelStyles}>{props.entity}</span>
            </div>
            <div className={styles.item}>
                <span className={boldLabelStyles}>{t('case')}:</span>
                <span className={normalLabelStyles}>{props.case}</span>
            </div>
            <div className={styles.item}>
                <span className={boldLabelStyles}>{t('jurisdiction')}:</span>
                <span className={normalLabelStyles}>{props.jurisdiction}</span>
            </div>
            <div className={styles.item}>
                <span className={boldLabelStyles}>{t('year')}:</span>
                <span className={normalLabelStyles}>{props.year}</span>
            </div>
        </div>
    );
};

export default ReportColumnContext;
